import PropTypes from 'prop-types';
import styled from 'styled-components';

const patternBg = `${process.env.PUBLIC_URL}/pattern-bg.jpg`;

const Wrapper = styled.header`
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 12rem;
  background-color: rgb(55, 65, 81);
  background-image: ${({ bg }) => `url(${bg})`};
  background-size: cover;
  position: relative;

  @media (min-width: 768px) {
    padding-bottom: 6rem;
  }

  &::after {
    content: '';
    display: block;
    height: 8px;
    background: radial-gradient(circle at 100% 50%, #34d399, #60a5fa);
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  & > * + * {
    margin-top: 1rem;
  }
`;

function Header({ children }) {
  return <Wrapper bg={patternBg}>{children}</Wrapper>;
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
